import { GuardModel } from "./guard-model";
import { TagModel } from "./tag-model";

export class TagLogModel {
    public Id: number;
    public TagId: number;
    public Tag: TagModel;
    public Time: Date;
    public GuardId: number;
    public Guard: GuardModel;
}



// WEBPACK FOOTER //
// ./src/app/models/tag-log-model.ts